import { useTheme } from './ThemeContext';

export default function ThemeSwitcher({ className = '' }) {
  const { isDark, toggleMode } = useTheme();
  return (
    <button
      onClick={toggleMode}
      className={className}
      title={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 6,
        padding: '5px 10px',
        borderRadius: 6,
        background: 'var(--g-accent-dim)',
        border: '1px solid var(--g-accent-border)',
        color: 'var(--g-accent-hi)',
        fontFamily: 'Inter, sans-serif',
        fontSize: 12,
        fontWeight: 600,
        cursor: 'pointer',
        transition: 'all 0.15s',
      }}
      onMouseEnter={e => {
        e.currentTarget.style.background = 'rgba(16,185,129,0.18)';
      }}
      onMouseLeave={e => {
        e.currentTarget.style.background = 'var(--g-accent-dim)';
      }}
    >
      <span className="material-symbols-outlined" style={{ fontSize: 14 }}>
        {isDark ? 'light_mode' : 'dark_mode'}
      </span>
      {isDark ? 'Light' : 'Dark'}
    </button>
  );
}
